import { Button, Space } from 'antd'
import { runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'
import React from 'react'
import './FormMultipleField.css'

interface FormMultipleFieldProps {
    field: any
    InputComponent: React.ComponentType<any>
}

export const FormMultipleField: React.FC<FormMultipleFieldProps> = observer(
    ({ field, InputComponent }) => {
        let values = field.value

        // Ініціалізуємо масив з одним порожнім елементом, якщо значення не є масивом
        if (!Array.isArray(values)) {
            runInAction(() => {
                field.formContext.setInitialValue(field.path, [''])
            })
            values = ['']
        }

        // Якщо масив порожній, додаємо один порожній елемент
        if (values.length === 0) {
            runInAction(() => {
                field.add('')
            })
            values = ['']
        }

        return (
            <div className="form-field-multiple">
                {values?.map((value: any, index: number) => {
                    return (
                        <Space key={`k${index}`} className="form-field-multiple-item">
                            <InputComponent field={field} index={index} />
                            {/* Кнопка видалення показується тільки якщо елементів більше одного */}
                            {values.length > 1 && (
                                <Button
                                    className="form-field-multiple-button-minus"
                                    style={{ width: '100%' }}
                                    type="dashed"
                                    onClick={() => field.remove(index)}
                                >
                                    -
                                </Button>
                            )}
                        </Space>
                    )
                })}
                <Button
                    className="form-field-multiple-buttom-plus"
                    type="dashed"
                    onClick={() => field.add('')}
                >
                    +
                </Button>
            </div>
        )
    }
)
